<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Chat App</div>
            </div>
                
            <!--page content-->
            <div class="admin-page-content">
                <section class="nc-chat-container">
                    <div class="container">
                        <div class="nc-chat-block">
                            <div class="nc-chat-left-container">
                                <div class="nc-chat-left-mobile">
                                    <div class="nc-chat-right-container-top">
                                        <a href="#" class="nc-back">
                                            <i class="fa fa-angle-left" aria-hidden="true"></i>
                                        </a>
                                        <div class="nc-chat-activer-user">
                                            <span>Users List</span>
                                        </div>
                                        <button type="submit" onclick="myFunction()">
                                            <span class="glyphicon glyphicon-search custom-search"></span>
                                        </button>
                                        <div id="myDIV" style="display: none;">
                                            <div class="input-group stylish-input-group">
                                                <input type="text" class="form-control"  placeholder="Search" >
                                                <span class="input-group-addon">
                                                    <button type="submit">
                                                        <span class="glyphicon glyphicon-search"></span>
                                                    </button>  
                                                </span>
                                            </div>
                                        </div>
                                        <div class="nc-chat-link" style="display: none;">
                                            <a href="#">
                                                <i class="fa fa-sign-out" aria-hidden="true"></i><br/>
                                                <span>End Chat</span>
                                            </a>
                                        </div>
                                        <div class="nc-chat-right-dropdown">
                                            <div class="dropdown">
                                                <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">
                                                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                                </button>
                                                <ul class="dropdown-menu">
                                                    <li><a href="#">HTML</a></li>
                                                    <li><a href="#">CSS</a></li>
                                                    <li><a href="#">JavaScript</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="nc-chat-type">
                                    <a href="#">Customers <sup>1</sup></a>
                                    <a href="#" class="active">Users</a>
                                </div>
                                <div class="nc-search">
                                    <div class="input-group stylish-input-group">
                                        <input type="text" class="form-control"  placeholder="Search" >
                                        <span class="input-group-addon">
                                            <button type="submit">
                                                <span class="glyphicon glyphicon-search"></span>
                                            </button>  
                                        </span>
                                    </div>
                                </div>
                                <ul class="nc-listing-container mCustomScrollbar" data-mcs-theme="minimal">
                                    <li class="nc-listing-block">
                                        <div class="nc-user-avtar">
                                            <img src="/static/images/default-img.png">
                                        </div>
                                        <div class="nc-user-info">
                                            <div class="nc-user-info-top">
                                                <div class="nc-user-name">Admin</div>
                                                <div class="nc-chat-time">5:42 PM</div>
                                            </div>
                                            <div class="nc-user-description">
                                                Lorem ipsum dolor sit amet, consectetuer
                                            </div>
                                            <div class="nc-new-chat-noti">1</div>
                                        </div>
                                    </li>
                                    <li class="nc-listing-block">
                                        <div class="nc-user-avtar">
                                            <img src="/static/images/default-img.png">
                                        </div>
                                        <div class="nc-user-info">
                                            <div class="nc-user-info-top">
                                                <div class="nc-user-name">James Smith (FAS)</div>
                                                <div class="nc-chat-time">5:42 PM</div>
                                            </div>
                                            <div class="nc-user-description">
                                                Lorem ipsum dolor sit amet, consectetuer
                                            </div>
                                        </div>
                                    </li>
                                    <li class="nc-listing-block">
                                        <div class="nc-user-avtar">
                                            <img src="/static/images/default-img.png">
                                        </div>
                                        <div class="nc-user-info">
                                            <div class="nc-user-info-top">
                                                <div class="nc-user-name">David (FAS)</div>
                                                <div class="nc-chat-time">5:42 PM</div>
                                            </div>
                                            <div class="nc-user-description">
                                                Lorem ipsum dolor sit amet, consectetuer
                                            </div>
                                        </div>
                                    </li>
                                    <li class="nc-listing-block">
                                        <div class="nc-user-avtar">
                                            <img src="/static/images/default-img.png">
                                        </div>
                                        <div class="nc-user-info">
                                            <div class="nc-user-info-top">
                                                <div class="nc-user-name">Maria Garcia (Velocity Rental)</div>
                                                <div class="nc-chat-time">5:42 PM</div>
                                            </div>
                                            <div class="nc-user-description">
                                                Lorem ipsum dolor sit amet, consectetuer
                                            </div>
                                        </div>
                                    </li>
                                    <li class="nc-listing-block">
                                        <div class="nc-user-avtar">
                                            <img src="/static/images/default-img.png">
                                        </div>
                                        <div class="nc-user-info">
                                            <div class="nc-user-info-top">
                                                <div class="nc-user-name">Robert Smith (Velocity Rental) </div>
                                                <div class="nc-chat-time">5:42 PM</div>
                                            </div>
                                            <div class="nc-user-description">
                                                Lorem ipsum dolor sit amet, consectetuer
                                            </div>
                                        </div>
                                    </li>
                                    <li class="nc-listing-block">
                                        <div class="nc-user-avtar">
                                            <img src="/static/images/default-img.png">
                                        </div>
                                        <div class="nc-user-info">
                                            <div class="nc-user-info-top">
                                                <div class="nc-user-name">Smith (Velocity Rental) </div>
                                                <div class="nc-chat-time">5:42 PM</div>
                                            </div>
                                            <div class="nc-user-description">
                                                Lorem ipsum dolor sit amet, consectetuer
                                            </div>
                                        </div>
                                    </li>
                                    <li class="nc-listing-block">
                                        <div class="nc-user-avtar">
                                            <img src="/static/images/default-img.png">
                                        </div>
                                        <div class="nc-user-info">
                                            <div class="nc-user-info-top">
                                                <div class="nc-user-name">Admin</div>
                                                <div class="nc-chat-time">5:42 PM</div>
                                            </div>
                                            <div class="nc-user-description">
                                                Lorem ipsum dolor sit amet, consectetuer
                                            </div>
                                            <div class="nc-new-chat-noti">1</div>
                                        </div>
                                    </li>
                                    <li class="nc-listing-block">
                                        <div class="nc-user-avtar">
                                            <img src="/static/images/default-img.png">
                                        </div>
                                        <div class="nc-user-info">
                                            <div class="nc-user-info-top">
                                                <div class="nc-user-name">James Smith (FAS)</div>
                                                <div class="nc-chat-time">5:42 PM</div>
                                            </div>
                                            <div class="nc-user-description">
                                                Lorem ipsum dolor sit amet, consectetuer
                                            </div>
                                        </div>
                                    </li>
                                    <li class="nc-listing-block">
                                        <div class="nc-user-avtar">
                                            <img src="/static/images/default-img.png">
                                        </div>
                                        <div class="nc-user-info">
                                            <div class="nc-user-info-top">
                                                <div class="nc-user-name">David (FAS)</div>
                                                <div class="nc-chat-time">5:42 PM</div>
                                            </div>
                                            <div class="nc-user-description">
                                                Lorem ipsum dolor sit amet, consectetuer
                                            </div>
                                        </div>
                                    </li>
                                    <li class="nc-listing-block">
                                        <div class="nc-user-avtar">
                                            <img src="/static/images/default-img.png">
                                        </div>
                                        <div class="nc-user-info">
                                            <div class="nc-user-info-top">
                                                <div class="nc-user-name">Maria Garcia (Velocity Rental)</div>
                                                <div class="nc-chat-time">5:42 PM</div>
                                            </div>
                                            <div class="nc-user-description">
                                                Lorem ipsum dolor sit amet, consectetuer
                                            </div>
                                        </div>
                                    </li>
                                    <li class="nc-listing-block">
                                        <div class="nc-user-avtar">
                                            <img src="/static/images/default-img.png">
                                        </div>
                                        <div class="nc-user-info">
                                            <div class="nc-user-info-top">
                                                <div class="nc-user-name">Robert Smith (Velocity Rental) </div>
                                                <div class="nc-chat-time">5:42 PM</div>
                                            </div>
                                            <div class="nc-user-description">
                                                Lorem ipsum dolor sit amet, consectetuer
                                            </div>
                                        </div>
                                    </li>
                                    <li class="nc-listing-block">
                                        <div class="nc-user-avtar">
                                            <img src="/static/images/default-img.png">
                                        </div>
                                        <div class="nc-user-info">
                                            <div class="nc-user-info-top">
                                                <div class="nc-user-name">Smith (Velocity Rental) </div>
                                                <div class="nc-chat-time">5:42 PM</div>
                                            </div>
                                            <div class="nc-user-description">
                                                Lorem ipsum dolor sit amet, consectetuer
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="nc-chat-right-container">
                                <div class="nc-chat-right-container-top">
                                    <a href="#" class="nc-back">
                                        <i class="fa fa-angle-left" aria-hidden="true"></i>
                                    </a>
                                    <div class="nc-chat-activer-user">

                                        <img src="/static/images/img.jpg">
                                        <span>Guest 1</span>
                                    </div>
                                    <div class="nc-chat-link">
                                        <a href="#">
                                            <!--<img src="images/end-chat1.png">--><span class="icon-End-chat"></span><br/>
                                            <span>End Chat</span>
                                        </a>
                                    </div>
                                    <div class="nc-chat-link">
                                        <a href="#" data-toggle="modal" data-target="#myModal">
                                            <!--<img src="images/forward1.png">--><span class="icon-Forward"></span><br/>
                                            <span>Forward</span>
                                        </a>
                                    </div>
                                </div>
                                <div class="nc-user-chat-area mCustomScrollbar" data-mcs-theme="minimal">
                                    <!--user chat-->
                                    <div class="nc-user-chat">
                                        <img src="/static/images/img.jpg">
                                        <div class="nc-user-chat-content">
                                            <p>Hi, Good Morning!!</p>
                                            <span>10:45 PM</span>
                                        </div>
                                    </div>
                                    <!--user chat-->
                                    <!--admin chat-->
                                    <div class="nc-admin-chat">
                                        <div class="nc-admin-chat-content">
                                            <span>10:45 PM</span>
                                            <p>Hi, Good Morning!!</p>
                                        </div>
                                    </div>
                                    <!--admin chat-->
                                    <!--user chat-->
                                    <div class="nc-user-chat">
                                        <img src="/static/images/img.jpg">
                                        <div class="nc-user-chat-content">
                                            <p>Lorem ipsum dolor sit amet,
                                                consectetuer adipiscing elit
                                            </p>
                                            <span>10:45 PM</span>
                                        </div>
                                    </div>
                                    <!--user chat-->
                                    <!--admin chat-->
                                    <div class="nc-admin-chat">
                                        <div class="nc-admin-chat-content">
                                            <span>10:45 PM</span>
                                            <p>Lorem ipsum dolor sit amet, consectetuer 
                                                adipiscing elit, sed diam nonummy nibh euismod
                                                tincidunt ut laoreet dolore magna aliquam.
                                            </p>
                                        </div>
                                    </div>
                                    <!--admin chat-->
                                    <!--user chat-->
                                    <div class="nc-user-chat">
                                        <img src="/static/images/img.jpg">
                                        <div class="nc-user-chat-content">
                                            <p>Hi, Good Morning!!</p>
                                            <span>10:45 PM</span>
                                        </div>
                                    </div>
                                    <!--user chat-->
                                    <!--admin chat-->
                                    <div class="nc-admin-chat">
                                        <div class="nc-admin-chat-content">
                                            <span>10:45 PM</span>
                                            <p>Hi, Good Morning!!</p>
                                        </div>
                                    </div>
                                    <!--admin chat-->
                                    <!--user chat-->
                                    <div class="nc-user-chat">
                                        <img src="/static/images/img.jpg">
                                        <div class="nc-user-chat-content">
                                            <p>Lorem ipsum dolor sit amet,
                                                consectetuer adipiscing elit
                                            </p>
                                            <span>10:45 PM</span>
                                        </div>
                                    </div>
                                    <!--user chat-->
                                    <!--admin chat-->
                                    <div class="nc-admin-chat">
                                        <div class="nc-admin-chat-content">
                                            <span>10:45 PM</span>
                                            <p>Lorem ipsum dolor sit amet, consectetuer 
                                                adipiscing elit, sed diam nonummy nibh euismod
                                                tincidunt ut laoreet dolore magna aliquam.
                                            </p>
                                        </div>
                                    </div>
                                    <!--admin chat-->
                                </div>
                                <div class="nc-comment-area">
                                    <textarea placeholder="Type your message here..."></textarea>
                                    <a href="#">

                                        <img src="/static/images/textarea-button.png">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>
<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/footer';


    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,

        },
        data() {
            return {
                dismissSecs: 10,
                dismissCountDown: 0,
                showDismissibleAlert: false
            }

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            showAlert() {
                this.dismissCountDown = this.dismissSecs
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/chat-app.vue